<template>
  <div class="cancel flex flex-col items-center bg-wild-sand pb-3 pt-6 sm:px-6">
    <BasePanel class="bg-white w-full max-w-6xl">
      <BasePanelHeader class="flex relative justify-between items-center">
        <span class="font-semibold text-abbey text-sm">Cancel Brand</span>
      </BasePanelHeader>

      <div class="flex flex-1 px-4 py-5">
        <Loading
          :class="[
            'flex flex-col w-full',
            {
              'justify-center items-center p-8': isLoading
            }
          ]"
          :isLoading="isLoading"
        >
          <template #success>
            <form class="flex flex-col" id="cancel" @submit.prevent="onSubmit">
              <div class="flex">
                <div class="flex flex-col" style="min-width: 300px">
                  <span class="mb-4">Schedule Cancellation</span>
                  <Calendar
                    :ref="calendarId"
                    :month="initialMonth"
                    :year="initialYear"
                    :dates="dates"
                    @day-click="onDayClick"
                  />

                  <div class="mt-8" style="height: 24px">
                    {{ scheduledFor }}
                  </div>
                </div>

                <div class="flex flex-col ml-12">
                  <div class="flex flex-col">
                    <span class="mb-2">Franchisor ID</span>
                    <input
                      class="border rounded"
                      type="text"
                      v-model="franchisorId"
                    />
                  </div>

                  <span class="py-4">OR</span>

                  <div class="flex flex-col mb-8">
                    <span class="mb-2">Franchisor ID</span>
                    <select class="border rounded" v-model="franchisorId">
                      <option
                        v-for="option in accessibleFranchisors"
                        :key="option.id"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="flex flex-col mt-8">
                <div>
                  <BaseButton
                    :class="[
                      'px-4 py-2 border rounded',
                      { 'cursor-not-allowed opacity-50': disable }
                    ]"
                    :disabled="disable"
                    >Submit</BaseButton
                  >
                </div>
              </div>
            </form>
          </template>
        </Loading>
      </div>
    </BasePanel>
  </div>
</template>

<style scoped>
input,
select {
  width: 350px;
}
</style>

<script>
import { Calendar, Loading } from '@listen360/alexandria'
import format from 'date-fns/format'
import { mapGetters } from 'vuex'

export default {
  name: 'Cancel',
  components: {
    Calendar,
    Loading
  },
  data() {
    const initialDate = new Date()

    return {
      calendarId: 'calendar-id',
      dates: [],
      franchisorId: '',
      initialMonth: initialDate.getMonth(),
      initialYear: initialDate.getFullYear(),
      submitted: false
    }
  },
  computed: {
    ...mapGetters({
      accessibleFranchisors: 'user/accessibleFranchisors'
    }),
    isLoading() {
      return this.accessibleFranchisors.length === 0 || this.submitted
    },
    disable() {
      return (
        !this.accessibleFranchisors.find(
          item => item.id === this.franchisorId
        ) || !this.dates[0]
      )
    },
    scheduledFor() {
      return this.dates[0]
        ? `Scheduled for: ${format(this.dates[0], 'MMMM do, yyyy')}`
        : null
    }
  },
  methods: {
    onDayClick(date) {
      this.dates = [date]
    },
    onSubmit() {
      this.submitted = true
    }
  },
  watch: {
    accessibleFranchisors(franchisors, oldFranchisors) {
      if (oldFranchisors.length === 0 && franchisors.length > 0) {
        this.franchisorId = franchisors[0].id
        this.selectedFranchisorId = franchisors[0].id
      }
    }
  }
}
</script>
